import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface LdcItem {
  LDC_DATE: string;
}

interface OptionType {
  value: string;
  label: string;
}
interface LdcState {
  data: LdcItem[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedLdc?: string[];
  selectedLdcList?: OptionType[];
}
const initialState: LdcState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedLdc: [],
  selectedLdcList: [],
};

export const fetchLdcDates = createAsyncThunk(
  "fetchLdcDates",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHLdcDATES, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const LdcSlice = createSlice({
  name: "LdcData",
  initialState,
  reducers: {
    UpdateSelectedLdc: (state, action) => {
      state.selectedLdc = action.payload;
    },
    UpdateSelectedLdcList: (state, action) => {
      state.selectedLdcList = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchLdcDates.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(fetchLdcDates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(fetchLdcDates.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {
  UpdateSelectedLdc,
  UpdateSelectedLdcList,
} = LdcSlice.actions;
export default LdcSlice.reducer;
